import { render, staticRenderFns } from "./CriterionTags.vue?vue&type=template&id=9fe20fac"
import script from "./CriterionTags.vue?vue&type=script&lang=js"
export * from "./CriterionTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports